module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "scrollContent"
  }, [_c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1",
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.settings), function(row) {
    return _c('tr', {
      class: {
        'trSelect': row.selected
      }
    }, [_c('td', {
      staticClass: "tdData  sp",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_vm._v(_vm._s(row.KeyName))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isEdit),
        expression: "!isEdit"
      }],
      staticClass: "tdData tdTxt",
      staticStyle: {
        "width": "160px!important"
      }
    }, [_vm._v(_vm._s(row.KeyValue))])])
  }))]) : _c('div', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("אין נתונים")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable",
    staticStyle: {
      "padding": "20px!important",
      "border": "none",
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "trPrint trHeader"
  }, [_c('th', {
    staticClass: "tdData sp",
    staticStyle: {
      "width": "160px!important"
    }
  }, [_vm._v("שם מפתח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData",
    staticStyle: {
      "width": "160px!important"
    }
  }, [_vm._v("ערך מפתח")]), _vm._v(" "), _c('th', {
    staticClass: "tdData",
    staticStyle: {
      "width": "150px!important"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5f1588c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableSettings.vue
// module id = 909
// module chunks = 2